const CHAT_BUBBLES = [
  ["self-start", "w-[62%]", "h-14"],
  ["self-start", "w-[44%]", "h-9"],
  ["self-end", "w-[52%]", "h-9"],
  ["self-start", "w-[70%]", "h-[76px]"],
  ["self-end", "w-[40%]", "h-9"],
  ["self-end", "w-[58%]", "h-14"],
  ["self-start", "w-[48%]", "h-9"],
];
// a channel: tall posts, all from one side
const CHANNEL_BUBBLES = [
  ["self-start", "w-[78%]", "h-[120px]"],
  ["self-start", "w-[70%]", "h-[76px]"],
  ["self-start", "w-[78%]", "h-40"],
  ["self-start", "w-[64%]", "h-[76px]"],
];

/** The pale bubbles themselves; also part of the page's server-rendered first frame. */
export const SkeletonBubbles = ({ channel = false }) => (
  <>
    {(channel ? CHANNEL_BUBBLES : CHAT_BUBBLES).map(([side, width, height], i) => (
      <span key={i} className={`${side} ${width} ${height} block animate-pulse rounded-2xl bg-white/80`} />
    ))}
  </>
);

/** From the first frame; it fades in, so a chat that loads at once only passes through it. */
export default function MessagesSkeleton({ channel = false }) {
  return (
    <div
      className="motion-fade-in pointer-events-none absolute inset-0 flex flex-col justify-end gap-2 overflow-hidden px-2.5 pb-[84px]"
      role="status"
      aria-label="در حال بارگذاری پیام‌ها"
    >
      <SkeletonBubbles channel={channel} />
    </div>
  );
}
